import type { ToastOptions } from '@common/hooks';
import { getSubDomain } from '@core/utils';
import * as Sentry from '@sentry/nextjs';
import { useRef } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { AuthApi } from '@/api';
import { STORAGE_KEY, SUB_DOMAIN } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { switchMyPageUser } from '@/stores/useMyPageStore';
import { useAccessToken } from './useAccessToken';
interface LogoutOptions {
  redirect?: string;
  forInit?: boolean;
  toastOptions?: ToastOptions;
}
export const useLogout = () => {
  const {
    setAccessToken,
    setRefreshToken
  } = useAccessToken();
  const [setMyInfo, setIsLogin, setIsDisabledAccessControl] = useAuthStore(useShallow(state => [state.setMyInfo, state.setIsLogin, state.setIsDisabledAccessControl]));
  const {
    current
  } = useRef({
    logout: async (options?: LogoutOptions) => {
      const {
        redirect,
        forInit,
        toastOptions
      } = options ?? {};
      sessionStorage.removeItem(STORAGE_KEY.POLICY_FILTER_LANDING);
      sessionStorage.removeItem(STORAGE_KEY.POLICY_FILTER);
      sessionStorage.removeItem(STORAGE_KEY.EASY_CERTIFICATION);
      if (toastOptions) {
        sessionStorage.setItem(STORAGE_KEY.LOGOUT_TOAST, JSON.stringify(toastOptions));
      }
      if (!forInit) {
        setIsDisabledAccessControl(true);

        // 서버에 로그아웃 요청 완료 후 페이지 이동
        try {
          await AuthApi['post:/wello/v2/auth/member-oauth/logout']();
        } catch {
          // 실패해도 클라이언트 로그아웃 진행
        }
      }
      setAccessToken(null);
      setRefreshToken(null);
      setMyInfo(null);
      setIsLogin(false);
      switchMyPageUser(null);
      Sentry.setUser(null);
      if (forInit || getSubDomain() === SUB_DOMAIN.KB_PAY) return;
      if (redirect) {
        return location.replace(redirect);
      }
      return location.reload();
    }
  });

  // eslint-disable-next-line react-hooks/refs -- 렌더마다 stable한 logout 함수 객체를 반환하기 위해 ref.current를 반환하는 의도적 패턴
  return current;
};